/**
 * Klaviyo Integration Module - Store-Agnostic
 * Shared by Survey Tool and Quiz Maker
 * Public key is passed via data attributes, never hardcoded.
 */
(function() {
  'use strict';

  window.KlaviyoIntegration = class KlaviyoIntegration {
    constructor(publicKey) {
      this.publicKey = publicKey;
      if (!this.publicKey) {
        console.warn('[KlaviyoIntegration] No public key provided');
      }
      window._learnq = window._learnq || [];
    }

    identify(email, properties) {
      if (!email) return;
      const payload = { '$email': email };
      Object.keys(properties || {}).forEach(function(key) {
        payload[key] = properties[key];
      });
      window._learnq.push(['identify', payload]);
    }

    track(eventName, properties) {
      if (!eventName) return;
      var payload = Object.assign({}, properties || {}, {
        'Timestamp': new Date().toISOString(),
        'Page URL': window.location.href,
        'Page Title': document.title
      });
      window._learnq.push(['track', eventName, payload]);
    }

    subscribe(email, listId, properties) {
      if (!email || !listId || !this.publicKey) return Promise.resolve();

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: properties && properties.source || 'Website',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: properties && properties.firstName || '',
                  properties: properties && properties.profileProps || {}
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      };

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.publicKey, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).catch(function(err) {
        console.error('[KlaviyoIntegration] Subscribe error:', err);
      });
    }

    trackSurvey(surveyId, surveyType, answers, email) {
      var props = {};
      if (answers) {
        Object.keys(answers).forEach(function(key) {
          var answer = answers[key];
          if (answer && answer.klaviyoProperty) {
            props[answer.klaviyoProperty] = answer.klaviyoValue || answer.value;
          }
        });
      }

      if (email) {
        this.identify(email, props);
      }

      this.track('Survey Completed', {
        'Survey ID': surveyId,
        'Survey Type': surveyType,
        'Answers': JSON.stringify(answers)
      });
    }

    trackQuizEvent(eventName, quizName, extraProps) {
      this.track(eventName, Object.assign({
        'Quiz Name': quizName
      }, extraProps || {}));
    }
  };
})();
